module.exports = __webpack_public_path__ + "static/img/01_christian_stemmler_cornelius_carstens.3a984c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/stemmi/01_christian_stemmler_cornelius_carstens.jpg
// module id = 3/0I
// module chunks = 1